module.exports = __webpack_public_path__ + "f1efece1df0f3ee0f642686465817fe4.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-medium.eot
// module id = 19
// module chunks = 0